// @ts-nocheck
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-shadow */
import React, { useState, useEffect, FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux'
// @ts-ignore
import { ReactComponent as CrossIcon } from 'Shared/img/svg/crossGray.svg'
import { getCookieByName, getUtmParameters } from 'Constants/functions'
import { campaignsList } from 'Router/routes'
import { setTrackToInitialState } from 'Redux/actions/trackActions'
import {
  setTiktokValueToWebhook,
  createCampaignWithoutSignup,
} from 'Redux/actions/campaignActions'
import { getCountry } from 'Redux/selectors/spotifyToken'

import {
  createdFirstCampaignEvent,
  fistCampaignArtistDetailsEvent,
  locationEvent,
  pageInfo,
  pageViewEvent,
  phoneNumberAddedEvent,
  registrationCompleteEvent,
} from 'Helpers/tagManager'
import { Track } from 'Types/index'
import UserRegisterForm from '../UserRegisterForm'

import { FormData, UserRegisterModalProps } from './UserRegisterModalProps'

import {
  RegisterWrapper,
  LoginTextBlock,
  LoginLink,
  LoginText,
  RegisterLogin,
  CrossBlock,
  CustomModal,
} from './styles'

const UserRegisterModal: FunctionComponent<UserRegisterModalProps> = ({
  toggle,
  modal,
  campaignType,
  isCheckedTikTok,
}) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const history = useHistory()

  const [spotifyTrack, setSpotifyTrack] = useState(null)

  const [emailExist, setEmailExist] = useState(false)

  const handleResetEmailExist = () => {
    setEmailExist(false)
  }
  const track: Track = useSelector(
    (state: RootStateOrAny) => state.spotifyTrack.track
  )

  const country: string = useSelector(getCountry)

  useEffect(() => {
    if (track) {
      setSpotifyTrack(track)
    } else {
      setSpotifyTrack(JSON.parse(localStorage.getItem('track')))
    }
  }, [track])

  useEffect(() => {
    locationEvent()
    pageViewEvent(null, pageInfo.createCampaignDetails)
  }, [])

  const setGTMEventWhenEnterPhoneNumber = () => {
    phoneNumberAddedEvent()
  }

  // fix in the future
  const genre_ids = []
  const language_ids = [3]
  const mood_ids = []

  const handleSubmit = (data: FormData): void => {
    const fullGcid = getCookieByName('_ga')
    const gcid = fullGcid ? fullGcid.slice(6) : undefined
    const utmStr = getCookieByName('soundCampaignUtm')
    const utmObj = getUtmParameters(utmStr)
    const url = window.location.href

    fistCampaignArtistDetailsEvent()

    isCheckedTikTok &&
      dispatch(
        setTiktokValueToWebhook(data.firstName, data.lastName, data.email)
      )

    if (spotifyTrack && data) {
      dispatch(
        createCampaignWithoutSignup(
          data,
          spotifyTrack,
          genre_ids,
          language_ids,
          mood_ids,
          gcid,
          utmObj,
          url,
          (error, res) => {
            if (error) {
              setEmailExist(true)
              localStorage.setItem('alreadyExistedEmail', data.email)
            } else {
              createdFirstCampaignEvent(campaignType, res)
              pageViewEvent(null, pageInfo.CreatedFirstCampaign)
              registrationCompleteEvent(campaignType, res)
              dispatch(setTrackToInitialState())
              localStorage.removeItem('track')
              //  eslint-disable-next-line @typescript-eslint/no-explicit-any
              localStorage.setItem('isTrackSubmittedModal', true as any)

              history.push(`${campaignsList}`)
            }
          },
          utmObj.ref
        )
      )
    }
  }

  if (!modal) {
    return null
  }

  return (
    <CustomModal>
      <CrossBlock onClick={toggle}>
        <CrossIcon />
      </CrossBlock>
      <RegisterWrapper>
        <h5>{t('login.yourContactDetails')}</h5>
        <UserRegisterForm
          country={country}
          emailExist={emailExist}
          setGTMevent={setGTMEventWhenEnterPhoneNumber}
          handleResetEmailExist={handleResetEmailExist}
          onSubmit={handleSubmit}
        />
      </RegisterWrapper>
      <LoginTextBlock>
        <LoginLink
          href={document.location.origin}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LoginText>{t('login.IAlreadyHaveAnAccount')}&#8194;</LoginText>
          <RegisterLogin>{t('login.login')}</RegisterLogin>
        </LoginLink>
      </LoginTextBlock>
    </CustomModal>
  )
}

export default UserRegisterModal
